export default "__VITE_ASSET__CzMzFcEy__"